import { Component, OnInit, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { MemberOrganizationInfoModel } from '../../models/member-organization-info.model';
import { environment, liteUserId } from 'src/environments/environment';
import { DataService } from '../../services/data.service';
import { ManageMembersService } from '../../services/manage-members.service';
import { BaseComponent } from '../../base/base.component';
import { fromEvent } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoadingService } from '../../services/loading.service';

declare let gigya: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent extends BaseComponent implements OnInit {
  showContent:boolean = false;
  memberOrganizationInfo: MemberOrganizationInfoModel;
  organizationId: string;
  apiEndpointBaseUrl: string;
  isLiteUser: boolean;
  isMember: boolean;

  constructor(
    private membersService: ManageMembersService,
    private loadingService: LoadingService,
    private router: Router,
    private dataService: DataService,
    private zone: NgZone
  ) {
    super();
    this.apiEndpointBaseUrl = environment.apiEndpointBaseUrl;
  }

  ngOnInit() {
    setTimeout(()=>this.showContent=true, 500);

    this.dataService.setOrganizationId(undefined);
    this.dataService.setInfo(undefined);

    gigya.accounts.verifyLogin({
      callback: this.verifyUserData.bind(this),
    });

    //EVENT COMING FROM CDC
    if (window) {
      fromEvent(window, 'onITULoginSelectOrganization')
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          this.onSelectOrganizationEventHandler();
          this.loadingService.start();
        });
    }
  }

  onSelectOrganizationEventHandler() {
    gigya.accounts.verifyLogin({
      callback: this.verifyUserData.bind(this),
    });
  }

  

  //Callback function to check the user data from session context
  public async verifyUserData(data) {    
    if (data.errorCode == 0) {
      this.updateMemberInfo(data.UID, data.profile.firstName, data.profile.lastName, data.profile.email);
      
      // Delay a second to wait for organization data context being correctly set on CDC JS
      await sleep(1000);
      
      gigya.accounts.b2b.getOrganizationContext({
        callback: this.verifyOrgData.bind(this),
      });
    } else {
      var params = {
        screenSet: 'ITU-RegistrationLogin',
        startScreen: 'itu-login-ui5-screen',
        containerID: 'loginScreen',
        onAfterSubmit: (event) => {
          if (event.screen == 'itu-login-ui5-screen') {
            if (event.response.status == 'OK') {
              this.updateMemberInfo(
                event.response.UID,
                event.response.profile.firstName,
                event.response.profile.lastName,
                event.response.profile.email
              );
            }
            if (event.response.status == 'FAIL') {
              this.dataService.setInfo(undefined);
            }
          }
          //COPIED JS FROM CDC JS
          if (event.screen == 'itu-confirmation-message') {
            if (event.response.status == 'OK') {
              var email = event.profile.email;
              var xmlHttp = new XMLHttpRequest();
              xmlHttp.open('POST', this.apiEndpointBaseUrl + 'registration-completion', false); // false for synchronous request
              xmlHttp.setRequestHeader('email', email);
              xmlHttp.onload = function () {
                if (xmlHttp.status === 200) {
                  return;
                } else {
                }
              };
              xmlHttp.send(null);
            }
            if (event.response.status == 'FAIL') {
            }
          }
          //COPIED JS FROM CDC JS
          if (event.screen == 'itu-new-affiliation') {
            if (event.response.status == 'OK') {
              var orgId = event.data.orgId;
              var email = event.profile.email;
              var xmlHttp = new XMLHttpRequest();
              xmlHttp.open('POST', this.apiEndpointBaseUrl + 'request-affiliation', false);
              xmlHttp.setRequestHeader('email', email);
              xmlHttp.setRequestHeader('organization', orgId);
              xmlHttp.onload = function () {
                if (xmlHttp.status === 200) {
                  return;
                } else {
                }
              };
              xmlHttp.send(null);
            }
            if (event.response.status == 'FAIL') {
            }
          }
        },
      };
      gigya.accounts.showScreenSet(params);
    }
  }

  //Callback function to check the organization data from session context
  public verifyOrgData(data) {
    if (data.errorCode == 0 && data.bpId != undefined && data.bpId != '') {
      gigya.accounts.getAccountInfo({
        callback: (accountInfo) => this.checkIsActiveRelationCallback.bind(this)(accountInfo, data.bpId),
        UID: this.memberOrganizationInfo.id,
        include: 'groups',
      });
    } else if (data.errorCode == 0 && data.bpId != undefined) {
      this.setLiteUserContext();
    } else {
      gigya.accounts.showScreenSet({
        screenSet: 'ITU-RegistrationLogin',
        startScreen: 'itu-multiple-org-selection',
        containerID: 'loginScreen',
      });
    }
  }

  public checkIsActiveRelationCallback(accountInfo, bpId) {
    let status = accountInfo.groups.organizations.filter((org) => (org.bpid == bpId))[0].status;
    if (status == 'inactive') {
      this.setLiteUserContext();
    } else if (status == 'active') {
      this.setOrganizationContext(bpId);
    }
  }

  public setOrganizationContext(bpId) {
    this.organizationId = bpId;
    this.dataService.setOrganizationId(bpId);
    this.updateMemberOrganizatinoInfo();
  }

  public setLiteUserContext() {
    this.isLiteUser = true;
    this.dataService.setOrganizationId(liteUserId);
    this.zone.run(() => {
      this.router.navigateByUrl(this.getRedirectUrl());
      this.loadingService.end();
    });
  }

  public updateMemberOrganizatinoInfo() {
    if (this.memberOrganizationInfo.id != undefined && this.organizationId != undefined) {
      if (this.organizationId == '') {
        this.setLiteUserContext();
      } else {
        this.membersService.getMemberOrganizationInfo(this.memberOrganizationInfo.id).subscribe((data) => {
            let updatedMemberOrganizationInfo = this.membersService.parseAndUpdateOrganizationInfo(
              data,
              this.memberOrganizationInfo,
              this.organizationId
            );
            this.memberOrganizationInfo = updatedMemberOrganizationInfo;
            this.getExtraOrganizationInfo();
          });
      }
    }
  }

  getExtraOrganizationInfo() {
    gigya.accounts.b2b.getOrganizationInfo({
      bpid: this.organizationId,
      callback: this.updateExtraInfo.bind(this),
    });
  }

  updateExtraInfo(data) {
    this.isMember = false;
    if (data.info.membership) {
      this.isMember = JSON.parse(data.info.membership[0]);
    }
    this.memberOrganizationInfo.member = this.isMember;
    this.memberOrganizationInfo.orgId = data.info.orgID;

    this.zone.run(() => {
      this.dataService.setInfo(this.memberOrganizationInfo);
      this.router.navigateByUrl(this.getRedirectUrl());
      this.loadingService.end();
    });
  }

  public updateMemberInfo(memberId: string, name: string, lastname: string, email: string) {
    this.memberOrganizationInfo = new MemberOrganizationInfoModel();
    this.memberOrganizationInfo.id = memberId;
    this.memberOrganizationInfo.name = name;
    this.memberOrganizationInfo.lastname = lastname;
    this.memberOrganizationInfo.email = email;
    this.memberOrganizationInfo.initials = name.charAt(0) + lastname.charAt(0);
    this.memberOrganizationInfo.complete = false;

    this.zone.run(() => {
      this.dataService.setInfo(this.memberOrganizationInfo);
    });
  }

  private getRedirectUrl(): string {
    let previousUrl: string = this.dataService.getPreviousUrl() || '/settings';
    if (previousUrl == '/' || this.isLiteUser || !this.isMember) {
      previousUrl = '/settings';
    }
    return previousUrl;
  }
}

async function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

